<template>
  <div @click="clickIcon">
    <svg class="icon-font" fill="currentColor" stroke="currentColor" aria-hidden="true">
      <use :xlink:href="'#' + iconName" fill="currentColor" stroke="currentColor"></use>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'HkjSvg',
  data() {
    return {

    }
  },
  props: {
    iconName: String
  },
  methods: {
    clickIcon() {
      this.$emit('clickIcon', this.iconName)
    }
  }
}
</script>
